// DNS Record interfaces
import { MX_PROVIDERS } from './constants';

export interface DNSRecord {
  name: string;
  value: string;
  type: string;
  is_active: boolean;
  valid: string;
}

export interface DNSRecordsTable {
  dns_records: {
    sending?: DNSRecord[];
    receiving?: DNSRecord[];
    tracking?: DNSRecord[];
  };
  mx_provider?: typeof MX_PROVIDERS[keyof typeof MX_PROVIDERS];
}

export interface FormattedDNSRecord {
  Host: string;
  RequiredValue: string;
  Type: string;
  Status: boolean;
  Valid: string;
}

export const formatDNSRecords = (
  recordsTable: DNSRecordsTable
): FormattedDNSRecord[] => {
  const TXTRecords =
    recordsTable?.dns_records?.sending?.map((record) => ({
      Host: record?.name ,
      RequiredValue: record?.value || '-',
      Type: record?.type || '-',
      Status: record?.is_active,
      Valid: record?.valid || 'unknown',
    })) || [];

  const MXRecords =
    recordsTable?.dns_records?.receiving?.map((record) => ({
      Host: record?.name,
      RequiredValue: record?.value || '-',
      Type: record?.type || '-',
      Status: record?.is_active,
      Valid: record?.valid || 'unknown',
    })) || [];

  // const CNAMERecords =
  //   recordsTable?.dns_records?.tracking?.map((record) => ({
  //     Host: record.name,
  //     RequiredValue: record.value,
  //     Type: record.type,
  //     Status: record.is_active,
  //     Valid: record?.valid || 'unknown',
  //   })) || [];

  return [
    ...TXTRecords,
    ...(recordsTable?.mx_provider === MX_PROVIDERS.NOT_FOUND ||
    recordsTable?.mx_provider === MX_PROVIDERS.MAILGUN
      ? MXRecords
      : []),
    // ...CNAMERecords,
  ];
};
